













import * as util from "@/util";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class NumberField extends Vue {
  @Prop({ default: 0 }) value!: number;
  @Prop({ default: false }) solo!: boolean;
  @Prop({ default: false }) required!: boolean;
  @Prop({ default: null }) rules!: util.ValidationRule[];
  @Prop({ default: null }) help!: string | null;

  get stringValue() {
    if (this.value === null || this.value === undefined) return 0;
    return this.value.toString();
  }

  get lang() {
    return this.$store.state.lang.data;
  }

  onInput(val: string | null) {
    let emitedValue = this.value;
    try {
      const v = Number(val);
      if (!isNaN(v)) {
        emitedValue = v;
      }
    } catch (e) {
      util.logError("Invalid NumberInput value", { val, tval: this.value, e });
    }
    this.$emit("input", emitedValue);
  }

  get allRules() {
    const allRules = [];
    if (this.required) allRules.push(util.rules.required(this.lang.ruleRequiredValue));
    allRules.push(util.rules.numeric(this.lang.ruleNumericValue, false, false));
    if (this.rules && this.rules.length > 0) {
      this.rules.forEach((r) => allRules.push(r));
    }
    return allRules;
  }
}
